import { AppNS } from 'app';

import { getAcknowledgementsByDisciplines } from '../qualifications-sections/sections/acknowledgements/config';
import { isFieldsExcluded } from '../qualifications-sections/sections/section-validation/SectionValidation';

export const isProfileCanBePublished = (company: AppNS.Company): boolean => {
  // Profile can be published when:
  // 1. Company has disciplines
  // 2. Company has price info (either fixed price or proposal price)
  // 3. Company has a merchant account connected and verified [optional not included anymore in check]
  // 4. Contact info is filled out
  // Conditionally
  // 5. For some disciplines there's a need to have pricing policy see isFieldsExcluded()
  // 6. Acknowledgements are accepted

  if (!isCompanyHasDisciplines(company)) {
    console.log('Company has no disciplines');
    return false;
  }

  if (!isCompanyHasPriceInfo(company)) {
    console.log('Company has no price info');
    return false;
  }

  if (!isCompanyHasContactInfo(company)) {
    console.log('Company has no contact info');
    return false;
  }

  if (!isCompanyHasAcknowledgementsAccepted(company)) {
    console.log('Company has no accepted acknowledgements');
    return false;
  }

  return true;
};

export const isCompanyHasDisciplines = (company: AppNS.Company): boolean => {
  return company.disciplines && company.disciplines.length > 0;
};

export const isCompanyHasPriceInfo = (company: AppNS.Company, forceDirectCheck = false): boolean => {
  // this is used when function was triggered live by the discipline selection change
  if (forceDirectCheck) {
    return isCompanyHasFixedPriceInfo(company) || isCompanyHasProposalPriceInfo(company);
  }
  const disciplinesIds = company.disciplines.map((d) => d.name);

  return (
    isFieldsExcluded(disciplinesIds) || isCompanyHasFixedPriceInfo(company) || isCompanyHasProposalPriceInfo(company)
  );
};

const isCompanyHasFixedPriceInfo = (company: AppNS.Company): boolean => {
  return company.fixedPriceBookingsEnabled && Boolean(company.fixedPriceList);
};

const isCompanyHasProposalPriceInfo = (company: AppNS.Company): boolean => {
  return company.proposalBookingsEnabled && Boolean(company.pricingPolicy);
};

export const isCompanyHasVerifiedMerchantAccount = (company: AppNS.Company): boolean => {
  return Boolean(company?.connectedAccount);
};

export const isCompanyHasVerifiedDoeeMerchantAccount = (company: AppNS.Company, forceDirectCheck = false): boolean => {
  // if forceDirectCheck is true, check only for doeeConnectedAccount
  // this is used when function was triggered live by the discipline selection change
  if (forceDirectCheck) {
    return Boolean(company?.doeeConnectedAccount);
  }

  // if discipline doee is selected, check for doeeConnectedAccount
  if (company.disciplines?.some((d) => d.name === 'doee')) {
    return Boolean(company?.doeeConnectedAccount);
  }
  return true;
};

export const isCompanyHasContactInfo = (company: AppNS.Company): boolean => {
  return (
    Boolean(company.pointOfContact) &&
    Boolean(company.contactEmail) &&
    Boolean(company.contactPhone) &&
    Boolean(company.address)
  );
};

export const isCompanyHasAcknowledgementsAccepted = (company: AppNS.Company): boolean => {
  if (isCompanyHasDisciplines(company)) {
    const disciplinesNames = company.disciplines.map((d) => d.name);
    const data = getAcknowledgementsByDisciplines(disciplinesNames);

    const companyAcknowledgements = company.acknowledgements || [];

    return data.every((item) => {
      return companyAcknowledgements.some((ack) => ack.acknowledgementId === item.id && ack.acknowledgedAt);
    });
  }
  return false;
};
